<template>
  <div class="initialContent">
    <div class="tile is-parent">
    <article class="tile is-child box">
      <p class="label">推荐ICON选择：</p>
      <div class="block icon-wrap">
        <el-select
          v-model="selectBloggerId"
          multiple
          filterable
          class='v-select'
          @change="changeValueBloggers"
          @remove-tag="removeBloggersTag"
          placeholder="请选择">
          <el-option
            v-for="item in initData.bloggers"
            :key="item.bloggerId"
            :label="item.name"
            :value="parseInt(item.bloggerId)">
          </el-option>
        </el-select>
      </div>
      <p class="label">推荐标签：</p>
      <div class="block icon-wrap">
        <el-select
          v-model="selectTagId"
          multiple
          filterable
          class='v-select'
          @change="changeOperationTags"
          @remove-tag="removeOperationTags"
          placeholder="请选择文章标签">
          <el-option
            v-for="item in initData.operationTags"
            :key="item.tagId"
            :label="item.tagName"
            :value="parseInt(item.tagId)">
          </el-option>
        </el-select>
      </div>
      <p class="label">专题选择：</p>
      <div class="block icon-wrap">
        <el-select
          v-model="selectTopicId"
          multiple
          filterable
          class='v-select'
          @change="changeValueTopic"
          @remove-tag="removeTopicTag"
          placeholder="请选择文章标签">
          <el-option
            v-for="item in initData.topics"
            :key="item.topicId"
            :label="item.name"
            :value="parseInt(item.topicId)">
          </el-option>
        </el-select>
      </div>

      <div class="block">
        <button class="button is-primary" @click="onConfirm()">确认</button>
      </div>
    </article>
  </div>
  </div>
</template>

<script type="text/babel">
  export default {
    data(){
      return {
        params: {
          bloggers: [],
          operationTags: [],
          topics: [],
        },
        initData: {
          bloggers: [],
          operationTags: [],
          topics: [],
        },
        selectBloggerId:[],// 存放已选的标签
        selectBloggerIdTemp:[],// 存放临时的标签
        selectTagId:[],
        selectTagIdTemp:[],
        selectTopicId:[],
        selectTopicIdTemp:[],
        visibleChange:false
      }
    },
    mounted:function () {
      this.$nextTick(function () {
        this.getInitialOptions();
        this.getSelectedOptions();
      })
    },
    methods:{
      getInitialOptions() {
        HttpRequest.get('/admin.php?method=fashion.getInitRecommend', {}).then(response => {
          if (response) {
            this.initData.bloggers = response.data.bloggers ? response.data.bloggers : [] ;
            this.initData.operationTags = response.data.operationTags ? response.data.operationTags : [] ;
            this.initData.topics = response.data.topics ? response.data.topics : [] ;
          }
        })
      },
      getSelectedOptions () {
        HttpRequest.get('/admin.php?method=fashion.getSelectedRecommend', {}).then(response => {
          if (response) {
            let resData=response.data;
            this.params.bloggers = resData.bloggers ? resData.bloggers : [] ;
            this.params.operationTags = resData.operationTags ? resData.operationTags : [] ;
            this.params.topics = resData.topics ? resData.topics : [] ;
            let that=this;
            resData.bloggers.forEach(function (item) {
              that.selectBloggerId.push(parseInt(item.bloggerId));
            });
            resData.operationTags.forEach(function (item) {
              that.selectTagId.push(parseInt(item.tagId));
            });
            resData.topics.forEach(function (item) {
              that.selectTopicId.push(parseInt(item.topicId));
            });
            this.selectBloggerIdTemp=this.selectBloggerId
            this.selectTagIdTemp=this.selectTagId
            this.selectTopicIdTemp=this.selectTopicId
          }
        })
      },
      changeValueBloggers(value){
        let that=this;
        value.forEach(function (item) {
          if(that.selectBloggerIdTemp.indexOf(item)===-1){
            that.selectBloggerIdTemp.push(item);
            that.initData.bloggers.forEach(function (initBloggers) {
              if(parseInt(initBloggers.bloggerId)===item){
                that.params.bloggers.push({bloggerId:item,name:initBloggers.name})
              }
            })
          }
        });
      },
      removeBloggersTag(removeItem){
        let that=this;
        this.params.bloggers.forEach(function (paramsTag,index) {
          if(parseInt(paramsTag.bloggerId)===removeItem.value){
            that.params.bloggers.splice(index,1)
          }
        });
      },
      changeOperationTags(value){
        let that=this;
        value.forEach(function (item) {
          if(that.selectTagIdTemp.indexOf(item)===-1){
            that.selectTagIdTemp.push(item);
            that.initData.operationTags.forEach(function (initOperationTags) {
              if(parseInt(initOperationTags.tagId)===item){
                that.params.operationTags.push({tagId:item,tagName:initOperationTags.tagName})
              }
            })
          }
        });
        this.visibleChange=false;
      },
      removeOperationTags(removeItem){
        let that=this;
        this.params.operationTags.forEach(function (paramsTag,index) {
          if(parseInt(paramsTag.tagId)===removeItem.value){
            that.params.operationTags.splice(index,1)
          }
        });
      },
      changeValueTopic(value){
        let that=this;
        value.forEach(function (item) {
          if(that.selectTopicIdTemp.indexOf(item)===-1){
            that.selectTopicIdTemp.push(item);
            that.initData.topics.forEach(function (initTopicId) {
              if(parseInt(initTopicId.topicId)===item){
                that.params.topics.push({topicId:item,name:initTopicId.name})
              }
            })
          }
        });
      },
      removeTopicTag(removeItem){
        let that=this;
        this.params.topics.forEach(function (paramsTag,index) {
          if(parseInt(paramsTag.topicId)===removeItem.value){
            that.params.topics.splice(index,1)
          }
        });
      },
      onConfirm() {
        let params = JSON.parse(JSON.stringify(this.params));
        HttpRequest.post('/admin.php?method=fashion.doSaveRecommend', params).then(response => {
          if ( response && response.data.success === 1 ) {
            this.$message('保存成功！')
          }
        })
      },
    }
  }
</script>

<style lang="less" scoped>
  .initialContent {
    .icon-wrap, .tag-wrap {
      display: flex;

      .v-select {
        flex: 1;
        margin: 0 10px;
      }
    }
    .el-select{
      .el-select__tags{
        .el-tag.el-tag--primary {
          background-color: #41b883;
          border-color: #fff;
          color: #000;
        }
      }
    }
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    background: #f3f3f3;
    color: #35495e;
    font-weight: 700;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.hover {
    background: #41b883;
    outline: none;
    color: #fff;
  }
  .el-select-dropdown.is-multiple .el-select-dropdown__item.selected.hover, .el-select-dropdown__item.hover, .el-select-dropdown__item:hover {
    background: #ff6a6a;
    color: #fff;
  }
</style>

